import HeroPng from '../../assets/images/hero.png';
import styles from './Hero.module.css';

const Hero = () => {
  return (
    <section className={styles.hero}>
      <img
        src={HeroPng}
        alt="Добро пожаловать!"
        className={styles.heroImage}
      />
      <p className={styles.heroText}>
        Detail Delivery — логистическая компания,<br />
        специализирующаяся на международных поставках,<br />
        включая товары с ограниченным доступом.
      </p>
    </section>
  );
};

export default Hero;
